import { onMounted, onUnmounted, reactive, ref, watch } from "vue";

let isListenerAttached = false;
const callbacks = new Set();

function globalMessageHandler(event) {
  // Validación común para todos los componentes
//   if (typeof event.data !== "object") return;
  
  // Ejecutar todos los callbacks registrados
  callbacks.forEach(callback => callback.handler(event));
}

export function usePostMessage(targetOrigin) {
  const messageData = ref(null);
  const isLoading = reactive({ value: false, response: "" });

  const sendMessage = (message, targetWindow = window.parent) => {
    isLoading.value = true;
    isLoading.response = message.type;

    if (targetWindow && targetOrigin) {
      targetWindow.postMessage(message, targetOrigin);
    }
  };

  const localHandler = (event) => {
    // Validamos que el mensaje provenga del dominio esperado
    // if (event.origin !== targetOrigin) return;

    // Aseguramos que el evento tenga el formato esperado
    // if (typeof event.data !== "object") return;

    // Guardamos el mensaje en la referencia reactiva
    messageData.value = event?.data;
    // isLoading.value = false;
  };

  watch(messageData, () => {
    isLoading.value = false;
  });

  onMounted(() => {
    // Registrar el callback en el conjunto global
    callbacks.add({
      handler: localHandler,
      origin: targetOrigin,
    });

    // // Agregar listener global solo una vez
    if (!isListenerAttached) {
      window.addEventListener("message", globalMessageHandler);
      isListenerAttached = true;
    }
    // window.addEventListener("message", localHandler);
  });

  onUnmounted(() => {
    // Limpiar el callback al desmontar
    callbacks.delete(localHandler);

    // // Remover listener global si no hay callbacks
    if (callbacks.size === 0 && isListenerAttached) {
      window.removeEventListener("message", globalMessageHandler);
      isListenerAttached = false;
    }
    // window.removeEventListener("message", localHandler);
  });

  return { sendMessage, messageData, isLoading };
}
